import {
	Component,
	ChangeDetectionStrategy,
	OnInit,
	OnDestroy,
	Input,
} from '@angular/core';
import { CmmsFiltersService } from '../services/cmms-filters.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { AuNativeInputModule } from '@shared/ui-components/au-native-input/au-native-input.module';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'search-bar',
	templateUrl: './search-bar.component.html',
	styleUrls: ['./search-bar.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [AuNativeInputModule, NgxTolgeeModule],
})
export class SearchBarComponent implements OnInit, OnDestroy {
	@Input() placeholderText: string;

	searchControl = new FormControl();

	private destroy$ = new Subject<void>();

	constructor(private filterService: CmmsFiltersService) {}

	ngOnInit(): void {
		this.filterService.clearSearch$
			.pipe(takeUntil(this.destroy$))
			.subscribe(() => this.searchControl.setValue(null, { emitEvent: false }));
	}

	searchHandler(value: string) {
		this.filterService.quickSearchValue$.next(value);
	}

	controlReadyHandler(control: FormControl) {
		this.searchControl = control;
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
